import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import UserService from "services/UserService";
import TextInput from "components/Input/TextInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import DateInput from "components/Input/DateInput.js";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ImageList from "@mui/material/ImageList";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import styled from "styled-components";
import { vehiclespagetext } from "variables/vehicles";
import { statusData, motorData } from "variables/lists/vehicles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { postVehicle, putVehicle } from "services/ConfigServices";
import { NotificationManager } from "react-notifications";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;


function VehicleDialog(props) {

  const { closeModal, refetch, setLoading, currentVehicle } = props;
  const advancedSearchContext = useContext(AdvancedSearchContext);

  console.log(currentVehicle);
  const { chartIdGroup } = advancedSearchContext;

  const [registration, setRegistration] = useState(currentVehicle?.registration || "");
  const [key, setKey] = useState(currentVehicle?.parameters.category || "");
  const [description, setDescription] = useState(currentVehicle?.parameters.description || "");
  const [datebegin, setDatebegin] = useState(currentVehicle?.parameters.datebegin || "");
  const [dateend, setDateend] = useState(currentVehicle?.parameters.dateend || "");
  const [status, setStatus] = useState(currentVehicle?.parameters.status || "waiting");
  const [name, setName] = useState(currentVehicle?.parameters.name || "");
  const [brand, setBrand] = useState(currentVehicle?.parameters.brand || "");
  const [model, setModel] = useState(currentVehicle?.parameters.model || "");
  const [comments, setComments] = useState(currentVehicle?.parameters.comments || "");
  const [motor, setMotor] = useState(currentVehicle?.parameters.motor || "essence");

  const [groups, setGroups] = useState(currentVehicle?.idgroup ? "" + currentVehicle.idgroup : "");
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const classes = useStyles();

  const handleRegistrationChange = (event) => { setRegistration(event.target.value); };
  const handleKeyChange = (event) => { setKey(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };
  const handleDatebeginChange = (event) => { setDatebegin(event.target.value); };
  const handleDateendChange = (event) => { setDateend(event.target.value); };
  const handleStatusChange = (event) => { setStatus(event.target.value); };
  const handleNameChange = (event) => { setName(event.target.value); };
  const handleBrandChange = (event) => { setBrand(event.target.value); };
  const handleModelChange = (event) => { setModel(event.target.value); };
  const handleCommentsChange = (event) => { setComments(event.target.value); };
  const handleMotorChange = (event) => { setMotor(event.target.value); };


  const handleSubmit = (event) => {
    if (currentVehicle)
      updateVehicle(event);
    else
      createVehicle(event);
  };

  useEffect(() => {
    if (!registration || !groups || groups.length === 0)
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  });

  const createVehicle = async (event) => {
    let newvehicle = {
      registration,
      parameters: {
        key,
        description,
        datebegin,
        dateend,
        status,
        name,
        brand,
        model,
        comments,
        motor,
      }
    }
    axios
      .post(
        postVehicle(groups),
        newvehicle
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        console.log(res);
        if (res.status == 200) {
          NotificationManager.success("Véhicule créé");
          refetch();
          closeModal();
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
        setLoading(false);
      });
  };

  const updateVehicle = async (event) => {
    let newvehicleparameters = {
      ...currentVehicle.parameters,
      key,
      description,
      datebegin,
      dateend,
      status,
      name,
      brand,
      model,
      comments,
      motor,
    }
    axios
      .put(
        putVehicle(currentVehicle.id, groups),
        newvehicleparameters
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        console.log(res);
        if (res.status == 200) {
          NotificationManager.success("Véhicule modifié");
          refetch();
          closeModal();
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
        setLoading(false);
      });
  };


  return (
    <>

      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={7} lg={7}>
            <div>
              <TextInput
                inputTitle={vehiclespagetext.registration}
                textInput={registration}
                handleTextInputChange={handleRegistrationChange}
                required
                disabled={currentVehicle}
              />
            </div>
            <div>
              <TextInput
                inputTitle={vehiclespagetext.key}
                textInput={key}
                handleTextInputChange={handleKeyChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={vehiclespagetext.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={vehiclespagetext.brand}
                textInput={brand}
                handleTextInputChange={handleBrandChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={vehiclespagetext.model}
                textInput={model}
                handleTextInputChange={handleModelChange}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={vehiclespagetext.motor}
                selectValue={motor}
                handleSelectValueChange={handleMotorChange}
                data={motorData}
              />
            </div>
            <div>
              <TextInput
                inputTitle={vehiclespagetext.description}
                textInput={description}
                handleTextInputChange={handleDescriptionChange}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={vehiclespagetext.status}
                selectValue={status}
                handleSelectValueChange={handleStatusChange}
                data={statusData}
              />
            </div>
            <div>
              <DateInput
                inputTitle={vehiclespagetext.datebegin}
                dateInput={datebegin}
                handleDateInputChange={handleDatebeginChange}
              />
            </div>
            <div>
              <DateInput
                inputTitle={vehiclespagetext.dateend}
                dateInput={dateend}
                handleDateInputChange={handleDateendChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={vehiclespagetext.comments}
                textInput={comments}
                handleTextInputChange={handleCommentsChange}
                multiline
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={6} md={5} lg={5}>
            <div
              className={classes.treeVisible}
            >
              <TreeLabel>Choix du périmètre</TreeLabel>
              <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                <EmbeddedEntitesTree
                  selectedIds={setGroups}
                  userSelectedIds={groups}
                  filterfromnode={"" + chartIdGroup[0]}
                />
              </ImageList>
            </div>
          </GridItem>
        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>
    </>
  );
}

export default VehicleDialog;
